import { format } from "date-fns";
import { FormItem, FormStepDefinition, TextAnswerFormat } from "../../../types/Survey";

export function getTypedNameFormItems(strings: { [key: string]: string }): FormItem[] {
    return [
        {
            identifier: "FirstName",
            type: "FormItem",
            answerFormat: {
                type: "TextAnswerFormat",
                multipleLines: false
            } as TextAnswerFormat,
            optional: false,
            text: strings["first-name-label"],
            placeholder: strings["required-field-placeholder"],
        },
        {
            identifier: "LastName",
            type: "FormItem",
            answerFormat: {
                type: "TextAnswerFormat",
                multipleLines: false
            } as TextAnswerFormat,
            optional: false,
            text: strings["last-name-label"],
            placeholder: strings["required-field-placeholder"]
        }
    ];
}

export function getConsentMarkdownAsForm(title: string, content: string): FormStepDefinition {
    return {
        title: title,
        text: content,
        type: "FormStep",
        formItems: []
    }
}

export function getSignatureDate(signatureDateFormat: "DateAndTime" | "Date" | undefined) {
    return format(new Date(), signatureDateFormat == "DateAndTime" ? "MM/dd/yy hh:mm a" : "MM/dd/yy")
}